/**
 * Nombre de la cookie HttpOnly que persiste la última ciudad detectada por
 * geolocalización (spec.md FR-013). No confundir con `LOCATION_COOKIE`
 * (`src/app/lib/constants.ts`), la cookie preexistente del selector manual —
 * ver research.md §4 para cómo se sincronizan.
 */
export const LOCATION_GEO_COOKIE = 'location_geo'

/**
 * Vigencia de `location_geo` y `location`: 7 días, renovada en cada escritura
 * (detección exitosa o elección manual — ambas comparten la misma política de
 * expiración, `saveDetectedLocation`/`setManualLocation` en `actions.ts`).
 * `spec.md` FR-013 documenta 30 días — reducido a 7 a petición explícita,
 * pendiente de actualizar esa spec si se retoma.
 */
export const LOCATION_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 7

/**
 * Timeout de `navigator.geolocation.getCurrentPosition` en ms — research.md §6.
 * Nombrada para poder ajustarla sin tocar la lógica del hook.
 */
export const GEOLOCATION_TIMEOUT_MS = 8000

/**
 * Antigüedad máxima de una posición ya conocida por el navegador que se acepta
 * sin pedir una nueva (`maximumAge` de `getCurrentPosition`). Para resolver la
 * provincia basta con una posición de hace unos minutos, y así no se espera a
 * un fix de GPS en cada visita con el spinner puesto.
 */
export const GEOLOCATION_MAX_AGE_MS = 10 * 60 * 1000

/**
 * Tope del spinner mientras se decide si redirigir (sobre todo con el aviso
 * de permiso del navegador abierto: su `timeout` no corre hasta que el usuario
 * responde, y algunos navegadores lo esconden). Se pausa mientras se espera al
 * banner de cookies y vuelve a contar entero al pedir la ubicación. Pasado este tiempo se quita el
 * spinner y ya NO se redirige — un cambio de página con el visitante ya
 * leyendo/haciendo scroll daría un salto. Si la ubicación llega después, solo
 * se guarda en la cookie para la próxima visita.
 */
export const GEOLOCATION_OVERLAY_MAX_MS = 6000

/**
 * Banner de cookies de OneTrust (CMP inyectado por GTM, fuera de este repo):
 * la ubicación no se pide hasta que se cierra — ver `waitForCookieBannerClosed`.
 * `OptanonAlertBoxClosed` la escribe OneTrust al aceptar/rechazar.
 */
export const COOKIE_BANNER_ID = 'onetrust-banner-sdk'
export const COOKIE_BANNER_CLOSED_COOKIE = 'OptanonAlertBoxClosed'
/** Cuánto se espera a que aparezca el banner antes de darlo por ausente (adblocker, GTM caído). */
export const COOKIE_BANNER_APPEAR_TIMEOUT_MS = 4000
export const COOKIE_BANNER_POLL_MS = 250

/**
 * Clave de `localStorage` que recuerda una denegación explícita del usuario,
 * para no volver a solicitar el permiso automáticamente (spec.md FR-006).
 */
export const LOCATION_PERMISSION_DENIED_KEY = 'location_permission_denied'
